import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

interface HealthResponse {
  version: string;
  env: string;
  /** Solo presente (y `true`) con MODO_PILOTO=1 en el backend: lo lee la
   *  franja del piloto (components/layout/franja-piloto.tsx). */
  piloto?: boolean;
}

// Versión + entorno que reporta el backend vivo (GET /api/health, público —
// sin cookie de sesión, se puede pedir antes de loguearse). La usa el footer
// de UserMenu para detectar cuándo esta pestaña quedó con un bundle viejo
// después de un deploy (Juan, 2026-09-14). staleTime alto: la versión del
// backend no cambia salvo un deploy nuevo, no hace falta repreguntar seguido.
// Desde el piloto 4.0.0 también la usa FranjaPiloto (campo `piloto`): misma
// query, un solo GET compartido por la franja y el popover.
export function useVersion() {
  return useQuery({
    queryKey: ['version'],
    queryFn: () => api<HealthResponse>('/api/health'),
    staleTime: 5 * 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
